module.exports = __webpack_public_path__ + "img/howto_step2_img.247d7778.png";